/* 🤖 this file was generated by svg-to-ts */
export const kzIconsProfil: {
  name: 'profil';
  data: string;
} = {
  name: 'profil',
  data: `<svg viewBox="0 0 18 22"><g stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M13 5.545C13 8.307 11.209 11 9 11S5 8.307 5 5.545C5 2.784 6.791 1 9 1s4 1.784 4 4.545ZM12.488 12C14.98 12 17 13.138 17 15.657V21M1 21v-5.343C1 13.137 3.02 12 5.512 12M4 18v3M13.5 18v3"/></g></svg>`
};
